const Images = {
	img1: require('./galaxy.png'),
	img2: require('./luxury-apt.png'),
	img3: require('./olpc.png'),
	img4: require('./premio.png'),
	img5: require('./quadmachine.png'),
	img6: require('./Bose.png'),
	img7: require('./leddartech.png'),
	img8: require('./Shenda.png'),
}

export default Images
